import "../../App.css";
import React, { lazy, Suspense, useEffect } from "react";
import Sidebar from "../../Module/sidebar";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import Loading from "../../Component/Loading";
import {
  InfraEmpPanelSidebarData,
  InfraPanelSidebarData,
} from "../../Module/infraPanelSidebarData";
import Chat from "../TeacherPanel/chat";
import { useSelector } from "react-redux";
import CommonRoutes from "../Common/commonRoute";
import { useDispatch } from "react-redux";
import { showSuccessSnackbar } from "../../Action/snackbarAction";
import { Logout, setInitialState } from "../../Action/authAction";

const CreateIssue = React.lazy(() => import("../InfraPanel/createIssue"));
const EditDeleteIssue = React.lazy(() =>
  import("../InfraPanel/editDeleteIssue")
);
const InfraIssue = React.lazy(() => import("../InfraPanel/infraIssue"));
const EmployeeAsset = React.lazy(() => import("./employeeAssets"));
const CreateEmployeeAsset = lazy(() =>
  import("./EmployeeAssets/createEmployeeAsset")
);
const ListEmployeeAsset = lazy(() =>
  import("./EmployeeAssets/listEmployeeAsset")
);
const MovementsOfMeeting = React.lazy(() =>
  import("../CategoryPanel/MovementsOfMeeting/movementsOfMeeting")
);
const EditMovementsOfMeeting = React.lazy(() =>
  import("../CategoryPanel/MovementsOfMeeting/editMovementsOfMeeting")
);

const DeviceDetail = React.lazy(() =>
  import("../InfraManagerPanel/deviceDetail")
);

function InfraPanelDashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginType, role, authToken } = useSelector((state) => ({
    designation: state.Auth?.userInfo?.designation,
    loginType: state.Auth?.loginType,
    role: state?.Auth?.userInfo?.role,
    authToken: state?.Auth?.authToken,
  }));

  useEffect(() => {
    if (!(role === "INFRA" && authToken)) {
      dispatch(setInitialState());
      navigate("/");
    }
  }, [role, dispatch, Navigate, authToken]);
  return (
    <div className="AppBox">
      <Sidebar
        data={
          loginType === 2 ? InfraEmpPanelSidebarData : InfraPanelSidebarData
        }
      />
      <div className="dashboard">
        {
          <CommonRoutes loginType={loginType} defaultPage={<CreateIssue />}>
            <Route path="/" element={<CreateIssue />} />
            <Route path="createIssue" element={<CreateIssue />} />
            <Route path="editDeleteIssue" element={<EditDeleteIssue />} />
            <Route path="infraIssue" element={<InfraIssue />} />
            <Route path="/Chat" element={<Chat />} />
            <Route path="/employeeAsset" element={<EmployeeAsset />} />
            <Route
              path="/createEmployeeAsset"
              element={<CreateEmployeeAsset />}
            />
            <Route path="/listEmployeeAsset" element={<ListEmployeeAsset />} />
            <Route path="movementsOfMeeting" element={<MovementsOfMeeting />} />
            <Route
              path="editMovementsOfMeeting"
              element={<EditMovementsOfMeeting />}
            />
            <Route path="deviceDetail" element={<DeviceDetail />} />
          </CommonRoutes>
        }
      </div>
    </div>
  );
}

export default InfraPanelDashboard;
